import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Map, List } from 'immutable';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as templateActions from 'modules/template';

import { ExamTemplateDelete } from 'components';

class CtExamTemplateDelete extends Component {
  constructor(props) {
    super(props);

    this.state = {
      deleting: false
    };
  }

  removeTemplate = async () => {
    this.setState({ deleting: true });

    const { mountDeleteModal, templateInfo: { templateNo, serviceTemplateNo } } = this.props;

    const params = {};
    let isOk = true;
    if (serviceTemplateNo) {
      params.serviceTemplateNo = serviceTemplateNo;
    } else if (templateNo) {
      params.examTemplateNo = templateNo;
    } else {
      // 오류
      isOk = false;
    }

    if (isOk) {
      try {
        const { TemplateActions } = this.props;
        await TemplateActions.deleteTemplate(params);
      } catch (e) {
        console.log(e);
      }
    } else {
      console.log('removeTemplate isOk fail!');
    }

    mountDeleteModal();
  };

  render() {
    const { deleting } = this.state;
    const { templateInfo, mountDeleteModal } = this.props;
    const { removeTemplate } = this;

    return (
      <ExamTemplateDelete
        deleting={deleting}
        templateInfo={templateInfo}
        removeTemplate={removeTemplate}
        handleOnToggleDeleteModal={mountDeleteModal}
      />
    );
  }
}

CtExamTemplateDelete.propTypes = {};
CtExamTemplateDelete.defaultProps = {};

const mapDispatchToProps = dispatch => ({
  TemplateActions: bindActionCreators(templateActions, dispatch)
});

export default connect(undefined, mapDispatchToProps)(CtExamTemplateDelete);



// WEBPACK FOOTER //
// ./src/script/containers/examTemplate/CtExamTemplateDelete.js